import { createContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import { client } from '../helper/apiCall';
import { useLocation } from 'react-router-dom';
import ENDPOINTS from '../constants/endpoints';
import { setAuthorities, setToken, setOwner } from '../store/slices/authSlice';

export const JWTContext = createContext();

const JWTProvider = ({ children }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const token = useSelector((state) => state.auth.token);

    useEffect(() => {
        if (!verifyToken(token)) {
            dispatch(setToken(''))
            dispatch(setOwner({}))
            dispatch(setAuthorities([]))
        }
    }, [location.pathname, token, dispatch]);

    const verifyToken = (serviceToken) => {
        if (!serviceToken) {
            return false;
        }
        const decoded = jwtDecode(serviceToken);
        return decoded.exp > Date.now() / 1000;
    };

    const login = async (username, password) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.post(ENDPOINTS.AUTH.LOGIN, { username, password });
                const { data } = response;
                
                // Yeni response yapısına göre token ve diğer bilgileri al
                const accessToken = data?.accessToken?.token;
                const owner = data?.owner;
                const claims = data?.claims;
                
                if (accessToken && verifyToken(accessToken)) {
                    dispatch(setToken(accessToken));
                    dispatch(setOwner(owner || {}));
                    dispatch(setAuthorities(claims || []));
                    resolve(response);
                } else {
                    reject(new Error('Invalid token'));
                }
            } catch (err) {
                reject(err);  
            }
        });
    };

    const logout = () => {
        dispatch(setToken(''))
        dispatch(setOwner({}))
        dispatch(setAuthorities([]))
    };

    return (
        <JWTContext.Provider value={{ login, logout }}>{children}</JWTContext.Provider>
    );
};

export default JWTProvider;